import { render, staticRenderFns } from "./DepositCryptoDetail.html?vue&type=template&id=5194e2f8&scoped=true&"
import script from "./DepositCryptoDetail.js?vue&type=script&lang=js&"
export * from "./DepositCryptoDetail.js?vue&type=script&lang=js&"
import style0 from "./DepositCryptoDetail.scss?vue&type=style&index=0&id=5194e2f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194e2f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
